<div *ngIf="seoEndOfContent$ | async as seoEndOfContent" class="container mb-5">
  <article
    class="rich-text"
    [innerHTML]="seoEndOfContent | safeSanitize: 'html'"></article>
</div>
